import { Box, Typography } from '@mui/material'
import React from 'react'

const ListBuilder = () => {
  return (
    <Box>
      <Typography variant="h4">List Builder</Typography>
    </Box>
  )
}

export default ListBuilder
